import React from "react";
import CallIcon from "@mui/icons-material/Call";

import PrimaryButton from "../../../widgets/Buttons/PrimaryButton";
import SecondaryButton from "../../../widgets/Buttons/SecondaryButton";
import CustomModal from "../../../widgets/Modal/CustomModal";
import ErrorSnackbar from "../../../widgets/Snackbar/ErrorSnackbar";
import SuccessSnackbar from "../../../widgets/Snackbar/SuccessSnackbar";
import useStudentInfoActions from "../hooks/useStudentInfoActions";
import styles from "../StudentDetails.module.scss";

const StudentCallAction = ({ studentData, verticalInfo }) => {
  const {
    confirmOpen,
    setConfirmOpen,
    errorSnackbar,
    successSnackbar,
    closeError,
    closeSuccess,
    isCalling,
    handleConnectCall,
  } = useStudentInfoActions({ studentData, verticalInfo });

  return (
    <>
      <SecondaryButton
        className={`${styles.headerButton} ${styles.headerCallButton} ${styles.callButtonHighlight}`}
        onClick={() => setConfirmOpen(true)}
        isLoading={isCalling}
        startIcon={!isCalling ? <CallIcon /> : null}
      >
        {isCalling ? "Calling" : "Call Student"}
      </SecondaryButton>

      <CustomModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        title="Confirm Action"
        maxWidth="xs"
        actions={
          <>
            <SecondaryButton onClick={() => setConfirmOpen(false)}>
              Cancel
            </SecondaryButton>
            <PrimaryButton onClick={handleConnectCall}>Confirm</PrimaryButton>
          </>
        }
      >
        <p className={styles.modalText}>
          Are you sure you want to proceed with <strong>Connect Call</strong>?
        </p>
      </CustomModal>

      <ErrorSnackbar
        open={errorSnackbar.open}
        message={errorSnackbar.message}
        onClose={closeError}
      />
      <SuccessSnackbar
        open={successSnackbar.open}
        message={successSnackbar.message}
        onClose={closeSuccess}
      />
    </>
  );
};

export default StudentCallAction;
